import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { mergeMap } from 'rxjs/operators';
import { GetGroupsErrorAction } from '../../actions/groups/get-groups-error-action';
import { GetModuleSubscriptionsAction } from '../../actions/module-subscriptions/get-module-subscriptions-action';
import { GetModuleSubscriptionsSuccessAction } from '../../actions/module-subscriptions/get-module-subscriptions-success-action';

@Injectable()
export class GetModuleSubscriptionsEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }


  public GetModuleSubscriptionsActions = createEffect(() => this.actions
    .pipe(
      ofType(GetModuleSubscriptionsAction.type),
      mergeMap(action => {
        const getModuleSubscriptionsAction = <GetModuleSubscriptionsAction>action;
        return this.api.getModuleSubscriptions(getModuleSubscriptionsAction.bijbEvent).then(moduleSubscriptions => {
          return new GetModuleSubscriptionsSuccessAction(moduleSubscriptions);
        }, error => {
          return new GetGroupsErrorAction({ ...error, fatal: true });
        });
      })
    ));
}
